import React, {Component} from 'react'
import {Col, Container, Row} from "react-bootstrap";

import teamAvatar1 from "../../../assets/img/demo/team-logo-1.png";
import teamAvatar2 from "../../../assets/img/demo/team-logo-2.png";
import playerAvatar1 from "../../../assets/img/demo/player-avatar-1.png";
import playerAvatar4 from "../../../assets/img/demo/player-avatar-4.png";
import playerAvatar5 from "../../../assets/img/demo/player-avatar-5.png";
import newsImage1 from "../../../assets/img/demo/news-image-1.png";
import newsImage2 from "../../../assets/img/demo/news-image-2.png";
import videoThumbnail1 from '../../../assets/img/demo/video-thumbnail-1.png';
import videoThumbnail2 from '../../../assets/img/demo/video-thumbnail-2.png';
import videoThumbnail3 from '../../../assets/img/demo/video-thumbnail-3.png';
import videoThumbnail4 from '../../../assets/img/demo/video-thumbnail-4.png';
import videoAvatar1 from "../../../assets/img/demo/video-avatar-1.png";
import videoAvatar2 from "../../../assets/img/demo/video-avatar-2.png";
import videoAvatar3 from "../../../assets/img/demo/video-avatar-3.png";
import videoAvatar4 from "../../../assets/img/demo/video-avatar-4.png";
import videoAvatar5 from "../../../assets/img/demo/video-avatar-5.png";
import {UpcomingMatches} from "../../ui/cards/UpcomingMatches";
import {ScoutingInvites} from "../../ui/cards/ScoutingInvites";
import {NewsAndUpdates} from "../../ui/cards/NewsAndUpdates";
import {Messages} from "../../ui/cards/Messages";
import {RecentAddedVideos} from "../../ui/cards/RecentAddedVideos";
import ShadowScrollbars from "../../ui/custom_scrollbars/ShadowScrollbars";
import SA_Welcome from '../../ui/sweetalert/SA_Welcome';

import '../../../assets/sass/dashboard.scss';
import '../../../assets/sass/pages/home.scss';

class Home extends Component {

    componentDidMount() {
        // Show Welcome Modal for New Users
        if(this.props?.location?.state?.isNew) {
            new SA_Welcome().fire()
        }
    }

    render = () => {
        // TODO: Remove following arrays and fill components from data source.

        let upcomingMatchesData = [
            {
                title: "Polokwane City VS Bloem Celtic",
                subtitle1: "Pietersburg Stadium",
                subtitle2: "SAPL Match 27",
                date: "Tomorrow",
                time: "12:00 AM",
                timeType: "Standard Time",
                avatar1: teamAvatar1,
                avatar2: teamAvatar2,
                badge: true,
            },
            {
                title: "Polokwane City VS Bloem Celtic",
                subtitle1: "Pietersburg Stadium",
                subtitle2: "SAPL Match 27",
                date: "Tomorrow",
                time: "12:00 AM",
                timeType: "Standard Time",
                avatar1: teamAvatar1,
                avatar2: teamAvatar2,
                badge: true,
            },
            {
                title: "Polokwane City VS Bloem Celtic",
                subtitle1: "Pietersburg Stadium",
                subtitle2: "SAPL Match 27",
                date: "Tomorrow",
                time: "12:00 AM",
                timeType: "Standard Time",
                avatar1: teamAvatar1,
                avatar2: teamAvatar2,
                badge: false
            },
        ];
        let scoutingInvitesData = [
            {
                name: "Jacob Howard",
                description: "Dreamer Sports Club",
                avatar: playerAvatar1,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: true,
            }, {
                name: "Jacob Howard",
                description: "Dreamer Sports Club",
                avatar: playerAvatar4,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: true,
            },
            {
                name: "Jacob Howard",
                description: "Dreamer Sports Club",
                avatar: playerAvatar5,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: false,
            }
        ];
        let messagesData = [
            {
                name: "Jacob Howard",
                description: "Hi how are you, I have a work offer for you. Reply back when you are available do discuss furthure",
                avatar: playerAvatar1,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: true,
            }, {
                name: "Jacob Howard",
                description: "Hi how are you, I have a work offer for you. Reply back when you are available do discuss furthure",
                avatar: playerAvatar4,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: false,
            },
            {
                name: "Jacob Howard",
                description: "Hi how are you, I have a work offer for you. Reply back when you are available do discuss furthure",
                avatar: playerAvatar5,
                datetime: "Today, 12:00 AM",
                detailsLink: "#",
                badge: false,
            }
        ];
        let newsAndUpdatesData = [
            {
                title: "Chelsea won by 2-0 against Liverpool",
                subtitle: "sportsnews.com",
                description: "Lorem ut culpa consectetur sint id do incididunt sint tempor irure magna. Non nostrud ipsum eu incidi...",
                image: newsImage1,
                datetime: "Today, 12:00 AM",
                badge: true,
            },
            {
                title: "Real Madrid won by 6-0 against Espanyol",
                subtitle: "sportsnews.com",
                description: "Lorem ut culpa consectetur sint id do incididunt sint tempor irure magna. Non nostrud ipsum eu incidi...",
                image: newsImage2,
                datetime: "Today, 12:00 AM",
                badge: false,
            },
        ];
        let recentAddedVideosData = [
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar1,
                thumbnail: videoThumbnail1,
                badge: true,
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar2,
                thumbnail: videoThumbnail2,
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar3,
                thumbnail: videoThumbnail3,
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar4,
                thumbnail: videoThumbnail4,
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar5,
                thumbnail: videoThumbnail1
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar2,
                thumbnail: videoThumbnail2
            },
            {
                name: "Mark Smith",
                description: "Team Name | League Name",
                avatar: videoAvatar3,
                thumbnail: videoThumbnail3
            },
        ];

        return this.wrapWithinScrollbar(
            <Container className="p-0" fluid={true}>
                <Row>
                    <Col className="card-container" xl={6} lg={12} md={12} sm={12}>
                        <UpcomingMatches subtitle={"2 New Matches"} data={upcomingMatchesData}/>
                    </Col>
                    <Col className="card-container" xl={6} lg={12} md={12} sm={12}>
                        <ScoutingInvites subtitle={"2 New Invites"} data={scoutingInvitesData}/>
                    </Col>
                    <Col className="card-container" xl={6} lg={12} md={12} sm={12}>
                        <NewsAndUpdates data={newsAndUpdatesData}/>
                    </Col>
                    <Col className="card-container" xl={6} lg={12} md={12} sm={12}>
                        <Messages subtitle={"1 New Messages"} data={messagesData}/>
                    </Col>
                    <Col className="card-container pb-0" xl={12} lg={12} md={12} sm={12}>
                        <RecentAddedVideos data={recentAddedVideosData}/>
                    </Col>
                </Row>
            </Container>
        );
    };

    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => ShadowScrollbars.wrapWithPadding(content);
}

export default Home;
